import React, { useContext, useEffect, useState } from 'react';
import AccountPickerContext from '../../contexts/AccountPickerContext';

type BonusBoardSignOffLookup = {
  [boardId: string]: BonusTypes.BoardSignOff | undefined;
};

export const BonusSubAppBoardSignOffsContext = React.createContext<{
  signOffLookup: BonusBoardSignOffLookup;
  isLoading: boolean;
}>({ signOffLookup: {}, isLoading: true });

const BonusSubAppBoardSignOffsProvider = ({
  children,
  app,
  selectedPeriodId,
}: {
  children: React.ReactNode;
  app: V3.BonusApp;
  selectedPeriodId: string;
}) => {
  const { selectedAccountId } = useContext(AccountPickerContext);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [signOffLookup, setSignOffLookup] = useState<BonusBoardSignOffLookup>(
    {},
  );

  useEffect(() => {
    setIsLoading(true);
    const signOffsForPeriod = app.signOffs.filter(
      (so) => so.periodId === selectedPeriodId,
    );

    const newLookup: BonusBoardSignOffLookup = {};
    signOffsForPeriod.forEach((s) => (newLookup[s.boardId] = s));

    setSignOffLookup(newLookup);
    setIsLoading(false);
  }, [app, selectedAccountId, selectedPeriodId]);

  return (
    <BonusSubAppBoardSignOffsContext.Provider
      value={{ signOffLookup, isLoading }}
    >
      {children}
    </BonusSubAppBoardSignOffsContext.Provider>
  );
};

export default BonusSubAppBoardSignOffsProvider;
